var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3827 1.38359C10.2717 1.29702 10.1351 1.25 9.99434 1.25C9.85362 1.25 9.71694 1.29702 9.606 1.38359L0.625 8.38709L1.40169 9.3694L2.5 8.51303V16.25C2.50068 16.5813 2.63259 16.8988 2.86686 17.1331C3.10114 17.3674 3.41869 17.4993 3.75 17.5H16.25C16.5813 17.4993 16.8989 17.3675 17.1332 17.1332C17.3675 16.8989 17.4994 16.5813 17.5 16.25V8.51871L18.5983 9.37496L19.375 8.39259L10.3827 1.38359ZM11.25 16.25H8.75V11.25H11.25V16.25ZM12.5 16.25V11.25C12.4996 10.9186 12.3678 10.6008 12.1335 10.3665C11.8991 10.1322 11.5814 10.0003 11.25 9.99996H8.75C8.41858 10.0003 8.10083 10.1321 7.86648 10.3664C7.63213 10.6008 7.50033 10.9185 7.5 11.25V16.25H3.75V7.5384L10 2.66965L16.25 7.54496V16.25H12.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7b50f9f7ea677a3b663b19ace1fa4924.svg";
export { ForwardRef as ReactComponent };